import { render } from "./ReportAccidents.vue?vue&type=template&id=4580bdb0"
import script from "./ReportAccidents.vue?vue&type=script&lang=js"
export * from "./ReportAccidents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportAccidents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4580bdb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4580bdb0', __exports__)) {
    console.log('reload')
    api.reload('4580bdb0', __exports__)
  }
  
  module.hot.accept("./ReportAccidents.vue?vue&type=template&id=4580bdb0", () => {
    console.log('re-render')
    api.rerender('4580bdb0', render)
  })

}


export default __exports__